var first_time = true;
var cachedFilterValues = [];
var cachedItems = [];
var cachedTotalCount = null;
var last_min_price = 0;
var last_max_price = 0;
var min_price = 0;
var max_price = 0;

function resolve_implicit_website_sort_filters(searchName, sortFilters) {
	sortFilters = sortFilters || {};
	const sorts = sortFilters.sorts;
	if (sorts && sorts.length && sorts[0]) {
		return sortFilters;
	}
	const hasSearch = !!(searchName && String(searchName).trim());
	return { sorts: [hasSearch ? "Default" : "Latest"] };
}

function website_sort_dropdown_label(sortValue) {
	const translate_dic = {
		default: "پیش فرض",
		"price ascending": "قیمت از کم به زیاد",
		"price descending": "قیمت از زیاد به کم",
		inventory: "موجودی",
		"a-z": "الف - ی ",
		"z-a": "ی - الف",
		ranking: "امتیاز",
		latest: "جدیدترین",
	};
	const key = String(sortValue || "").toLowerCase();
	return translate_dic[key] || sortValue;
}

erpnext.ProductView = class {
	/* Options:
		- View Type
		- Products Section Wrapper,
		- Item Group: If its an Item Group page
	*/
	constructor(options) {
		Object.assign(this, options);
		this.preference = this.view_type;
		this.theme = this.all_products_theme || "Theme 1";
		this.make();
		this.products_section.prepend(`
			<style>
				.skeleton {
					background: linear-gradient(-90deg, #f0f0f0 0%, #c6c6c6 50%, #f0f0f0 100%);
					background-size: 400% 400%;
					animation: shimmer 1.2s ease-in-out infinite;
					border-radius: 4px;
				}

				@keyframes shimmer {
					0% {
					background-position: 100% 0;
					}
					100% {
					background-position: -100% 0;
					}
				}

				.skeleton-line {
					height: 1rem;
					margin: 0.5rem 0;
				}
			</style>
		`);
	}

	make(from_filters = false) {
		this.products_section.empty();
		this.prepare_toolbar();
		this.get_item_filter_data(from_filters);
	}

	prepare_toolbar() {
		this.products_section.append(`
			<div class="toolbar d-flex">
			</div>
		`);
		// this.prepare_search();
		this.prepare_view_toggler();

		new erpnext.ProductSearch();
	}

	prepare_view_toggler() {
		if (!$("#list").length || !$("#image-view").length) {
			this.render_view_toggler();
			this.bind_view_toggler_actions();
			this.set_view_state();
		}
	}

	showSkeleton(selector, options = {}) {
		const {
			count = 3,
			height = '1rem',
			className = '',
			minWidth = 30, // in percent
			maxWidth = 100 // in percent
		} = options;
	
		const containers = document.querySelectorAll(selector);
		if (containers.length <= 0) 
			return;

		for(var container of containers){
			if (!container.hasAttribute('data-original-html')) {
				container.setAttribute('data-original-html', container.innerHTML);
			}
		
			container.innerHTML = '';
		
			for (let i = 0; i < count; i++) {
				const div = document.createElement('div');
				div.className = `skeleton skeleton-line ${className}`;
				div.style.height = height;
		
				// Generate varied width
				let width;
				if (i === count - 1) {
					// Make the last line usually shorter (like paragraph ending)
					width = Math.floor(Math.random() * 20) + minWidth; // 60–80%
				} else {
					width = Math.floor(Math.random() * (maxWidth - minWidth + 1)) + minWidth;
				}
				div.style.setProperty('width', `${width}%`, 'important');
		
				container.appendChild(div);
			}
		}
	}
	
	hideSkeleton(selector) {
		const containers = document.querySelectorAll(selector);
		if (containers.length <= 0) 
			return;

		for(var container of containers){
			const originalHTML = container.getAttribute('data-original-html');
			if (originalHTML !== null) {
				container.innerHTML = originalHTML;
				container.removeAttribute('data-original-html');
			}
		}
	}

	setLoader(target, enable = true) {
		const $target = $(target);
		if (!$target.length) return;
	
		if (enable) {
			$target.html(`<div class="spinner-border spinner-border-sm text-secondary" role="status"></div>`);
		} else {
			$target.empty(); // or set actual content after loading
		}
	}

	get_item_filter_data(from_filters = false) {
		let loader = $(
			'<div class="loader-box" style="display: flex; justify-content: center; height: 80vh; align-items: center;"><div class="spinner-border" role="status"> <span class="sr-only"></span></div></div>'
		);
		this.products_section.append(loader);
		// Get and render all Product related views
		let me = this;
		this.from_filters = from_filters;
		let args = this.get_query_filters();
		// Only calculate total count on initial load or when filters change
		args.calculate_total_count = from_filters || cachedTotalCount === null;
		// if (!from_filters && args.start == null) {
		// 	args.existence_filters.has_selling_stock = [1];
		// 	me.has_price_range()
		// }

		this.disable_view_toggler(true);

		if(args['search_name'] && args['search_name'].length > 0){
			if($("#search-box")){
				$("#search-box").val(args['search_name']);
			}
		}

		frappe.call({
			method: "erpnext.e_commerce.api.get_product_filter_data",
			args: {
				query_args: args,
				fill_filters: first_time,
			},
			callback: function (result) {

				if (
					!result ||
					result.exc ||
					!result.message ||
					result.message.exc
				) {
					me.render_no_products_section(true);
				} else {
					// Store total count if calculated, otherwise use cached value
					if (result.message["items_count"] !== null && result.message["items_count"] !== undefined) {
						cachedTotalCount = result.message["items_count"];
					}
					const itemsCount = result.message["items_count"] !== null && result.message["items_count"] !== undefined
						? result.message["items_count"]
						: cachedTotalCount;

					if (!result.message["items"].length) {
						// if result has no items or result is empty
						me.render_no_products_section();
						loader.remove();

					} else {
						// if (first_time) {
						// 	me.render_filters(result.message["filters2"]);
						// 	first_time = false;
						// }
						var start = 0;
						// Render views
						if (parseInt(args.start)) {
							var start = parseInt(args.start);
						}
						// me.render_list_view(result.message["items"], result.message["settings"],(start + result.message["items_count"]));

						cachedItems = result.message["items"];
						const _settings = result.message["settings"];
						const _items = result.message["items"];
						const _lazy_batch = cint(_settings.lazy_load_batch_size) || 0;
						// Progressive mode splits the DOM into batches; skip it unless there are
						// enough items for at least two full batches (avoids tiny tails e.g. 12 with batch 10).
						if (_lazy_batch > 0 && _items.length >= _lazy_batch * 2) {
							me.render_grid_view_progressive(
								_items,
								_settings,
								result.message["items_count"]
							);
						} else {
							me.render_grid_view(
								_items,
								_settings,
								result.message["items_count"]
							);
						}
					}

				// Bind filter actions
				if (!from_filters) {
					// me.has_selling_stock(me.get_query_filters()); // Removed: filter should be off by default
					me.has_price_range();
					// If `get_product_filter_data` was triggered after checking a filter,
					// don't touch filters unnecessarily, only data must change
					// filter persistence is handle on filter change event
					me.bind_filters();
					me.restore_filters_state();
				}

					// Bottom paging
					me.add_paging_section(
						result.message["settings"],
						itemsCount,
						result.message["item_group_description"]
					);
				}

				me.disable_view_toggler(false);
				// Re-enable and re-bind pagination after AJAX updates
				$(".btn-prev, .btn-next, .btn-num").prop("disabled", false);
			},
		});

		const refreshFilterFacets = first_time || from_filters;
		if (first_time) {
			first_time = false;
		}

		if (!refreshFilterFacets) {
			return;
		}

		me.showSkeleton('.desktop-filters-section', { count: 18, height: '20px', className: 'w-100' });
		frappe.call({
			method: "erpnext.e_commerce.api.get_filters",
			args: {
				query_args: args,
				fill_filters: true,
			},
			callback: function (result) {
				if(result.message){
					me.hideSkeleton('.desktop-filters-section');
					me.render_filters(result.message);
					me.restore_filters_state();
				}
			},
		});
		
	}

	disable_view_toggler(disable = false) {
		$("#list").prop("disabled", disable);
		$("#image-view").prop("disabled", disable);
	}

	render_grid_view(items, settings, count) {
		// loop over data and add grid html to it
		let me = this;
		this.prepare_product_area_wrapper("grid", count);

		new erpnext.ProductGrid({
			items: items,
			products_section: $("#products-grid-area"),
			settings: settings,
			preference: me.preference,
			theme: me.theme,
		});
	}

	render_grid_view_progressive(items, settings, count) {
		let me = this;
		this.prepare_product_area_wrapper("grid", count);

		const batch_size = cint(settings.lazy_load_batch_size) || 0;
		if (batch_size <= 0 || items.length <= batch_size) {
			me.render_grid_view(items, settings, count);
			return;
		}

		let loadedCount = batch_size;

		const grid = new erpnext.ProductGrid({
			items: items.slice(0, batch_size),
			products_section: $("#products-grid-area"),
			settings: settings,
			preference: me.preference,
			theme: me.theme,
			onReady: () => {
				const sentinel = $('<div class="product-grid-progressive-sentinel" data-sentinel="1" style="width:0;height:0;overflow:hidden;flex-shrink:0;flex-basis:0;"></div>');
				$("#products-grid-area").append(sentinel);

				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach((entry) => {
							if (!entry.isIntersecting || loadedCount >= items.length) return;
							const start = loadedCount;
							const next_batch = items.slice(start, start + batch_size);
							grid.appendItems(next_batch);
							loadedCount += next_batch.length;
							if (loadedCount >= items.length) {
								sentinel.remove();
								observer.disconnect();
							}
						});
					},
					{ rootMargin: "100px", threshold: 0 }
				);
				observer.observe(sentinel[0]);
			},
		});
	}

	render_list_view(items, settings, count) {
		let me = this;
		this.prepare_product_area_wrapper("list", count);

		new erpnext.ProductList({
			items: items,
			products_section: $("#products-list-area"),
			settings: settings,
			preference: me.preference,
		});
	}

	prepare_product_area_wrapper(view, count) {
		let left_margin = view == "list" ? "ml-2" : "";
		let top_margin = view == "list" ? "mt-6" : "mt-minus-1";
		let sort = $(".total-item-qty");
		let item_count = document.getElementById("item-count");
		if(item_count){
			item_count.innerHTML = count;
		}
		// Ensure only one grid area so progressive load shows items at top
		this.products_section.find("#products-grid-area").remove();
		// sort.append(`${count}`)
		return this.products_section.append(`
			<div id="products-grid-area" class="products-list justify-content-start flex-row-reverse d-flex col-12 p-0 flex-wrap mt-3 ${top_margin} mx-0"></div>
		`);
	}

	get_query_filters() {
		const filters = frappe.utils.get_query_params();
		let {
			field_filters,
			attribute_filters,
			specification_filters,
			name,
			brand_name,
			item_category,
			tag_filters,
			sort_filters,
			existence_filters,
			price_range_filters,
		} = filters;

		field_filters = this.convert_arabic_persian(field_filters);
		attribute_filters = this.convert_arabic_persian(attribute_filters);
		specification_filters = this.convert_arabic_persian(
			specification_filters
		);
		name = this.convert_arabic_persian(name);
		brand_name = this.convert_arabic_persian(brand_name);
		item_category = this.convert_arabic_persian(item_category);
		tag_filters = this.convert_arabic_persian(tag_filters);
		sort_filters = this.convert_arabic_persian(sort_filters);

		field_filters = field_filters ? JSON.parse(field_filters) : {};
		attribute_filters = attribute_filters
			? JSON.parse(attribute_filters)
			: {};
		specification_filters = specification_filters
			? JSON.parse(specification_filters)
			: {};
		brand_name = brand_name ? JSON.parse(brand_name) : {};
		item_category = item_category ? JSON.parse(item_category) : {};
		tag_filters = tag_filters ? JSON.parse(tag_filters) : {};
		sort_filters = sort_filters ? JSON.parse(sort_filters) : {};
		existence_filters = existence_filters
			? JSON.parse(existence_filters)
			: {};
		price_range_filters = price_range_filters
			? JSON.parse(price_range_filters)
			: {};
		name = name;

		this.item_group = $("#item_group_holder").val();
		this.item_category = $("#item_category_holder").val();

		this.custom_sp = $("#custom_sp").val();
		this.custom_value = $("#custom_value").val();

		var tag_filter = $("#tag_filters").val();

		if (tag_filter){
		

			tag_filters = { 'tags': [`${tag_filter}`] }
		}

	
		

		// existence_filters.has_selling_stock = $('#myCheckbox').is(':checked');
		sort_filters = resolve_implicit_website_sort_filters(name, sort_filters);
		return {
			field_filters: field_filters,
			attribute_filters: attribute_filters,
			specification_filters: specification_filters,
			search_name: name,
			brand_name: brand_name,
			item_category: this.item_category,
			custom_sp: this.custom_sp,
			custom_value: this.custom_value,
			tag_filters: tag_filters,
			sort_filters: sort_filters,
			existence_filters: existence_filters,
			price_range_filters: price_range_filters,
			item_group: this.item_group,
			start: filters.start || null,
			from_filters: this.from_filters || false,
		};
	}

	add_paging_section(settings, count, description) {
		$(".product-paging-area").remove();

		if(count <= 0){
			return;
		}

		let paging_html = `
			<style>
				.product-paging-area .btn.btn-num.active-page {
					background-color: var(--primary);
					color: white;
				}
					.product-paging-btn button{
						border-radius: 4px;
					}
			</style>
			<div class="row product-paging-area mt-5" style="justify-content: center">
				<div class="col-11 col-md-12 text-right d-flex flex-wrap product-paging-btn" style="justify-content: center; flex-direction: row-reverse;gap: 8px;">
		`;
		let query_params = frappe.utils.get_query_params();
		let start = query_params.start
			? cint(JSON.parse(query_params.start))
			: 0;
		let page_length = settings.products_per_page || 0;

		let prev_disable = start > 0 ? "" : "disabled";
		let next_disable =
			this.product_count > page_length ? "" : "disabled";

		paging_html += `
			<button class="btn btn-primary btn-prev" data-start="${
				start - page_length
			}" style="float: left" ${prev_disable}>
				قبلی
			</button>`;

		const totalPages = Math.ceil(count / settings.products_per_page);
		const currentPage =
			Math.floor(start / settings.products_per_page) + 1;
		const maxVisiblePages = 4;

		// Helper function to add a page button
		const addPageButton = (page, activeClass = "") => {
			paging_html += `<button class="btn btn-num ${activeClass}" data-start="${
				(page - 1) * settings.products_per_page
			}">${page}</button>`;
		};

		// Generate page buttons dynamically based on current page
		let startPage = Math.max(1, currentPage - maxVisiblePages);
		let endPage = Math.min(
			totalPages,
			currentPage + maxVisiblePages - 1
		);

		if (startPage > 1) {
			for (let i = 1; i <= 2; i++) {
				const activeClass = i === currentPage ? "active-page" : "";
				addPageButton(i, activeClass);
			}
			if (startPage > 3) {
				paging_html += `<span style="margin: 0 10px">...</span>`;
			}
		}

		for (let i = startPage; i <= endPage; i++) {
			const activeClass = i === currentPage ? "active-page" : "";
			addPageButton(i, activeClass);
		}

		if (endPage < totalPages) {
			if (endPage < totalPages - 2) {
				paging_html += `<span style="margin: 0 10px">...</span>`;
			}
			for (let i = totalPages - 1; i <= totalPages; i++) {
				const activeClass = i === currentPage ? "active-page" : "";
				addPageButton(i, activeClass);
			}
		}

		if (currentPage < totalPages) {
			paging_html += `
				<button class="btn btn-primary btn-next" data-start="${
					start + page_length
				}" ${next_disable}>
					بعدی
				</button>
			`;
		}

		paging_html += `</div></div>`;
		$(".search-pagination-container").append(paging_html);
		this.bind_paging_action();
		this.bind_number_paging_action();
	}

	// prepare_search() {
	// 	$(".toolbar").append(`
	// 		<div class="input-group col-8 p-0">
	// 			<div class="dropdown w-100" id="dropdownMenuSearch">
	// 				<input type="search" name="query" id="search-box" class="form-control font-md"
	// 					placeholder="جستجوی محصول"
	// 					aria-label="Product" aria-describedby="button-addon2">
	// 				<div class="search-icon">
	// 					<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
	// 						fill="none"
	// 						stroke="currentColor" stroke-width="2" stroke-linecap="round"
	// 						stroke-linejoin="round"
	// 						class="feather feather-search">
	// 						<circle cx="11" cy="11" r="8"></circle>
	// 						<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
	// 					</svg>
	// 				</div>
	// 				<!-- Results dropdown rendered in product_search.js -->
	// 			</div>
	// 		</div>
	// 	`);
	// }

	render_view_toggler() {
		//***by loading page in all-products user see items in grid manner */
		let $btn = $(this);
		$btn.removeClass("btn-primary");
		$btn.addClass("btn-primary");
		$(".btn-list-view").removeClass("btn-primary");
		$("#products-list-area").addClass("hidden");
		$("#products-grid-area").removeClass("hidden");
		localStorage.setItem("product_view", "Grid View");

		//*** comment btn of showing items */

		// $(".toolbar").append(`<div class="toggle-container col-4 p-0 d-flex justify-content-end"></div>`);

		// ["btn-list-view", "btn-grid-view"].forEach(view => {
		// 	let icon = view === "btn-list-view" ? "list" : "image-view";
		// 	$(".toggle-container").append(`
		// 		<div class="form-group mb-0" id="toggle-view">
		// 			<button id="${ icon }" class="btn ${ view } mr-2">
		// 				<span>
		// 					<svg class="icon icon-md">
		// 						<use href="#icon-${ icon }"></use>
		// 					</svg>
		// 				</span>
		// 			</button>
		// 		</div>
		// 	`);
		// });
	}

	bind_view_toggler_actions() {
		$("#list").click(function () {
			let $btn = $(this);
			$btn.removeClass("btn-primary");
			$btn.addClass("btn-primary");
			$(".btn-grid-view").removeClass("btn-primary");

			$("#products-grid-area").addClass("hidden");
			$("#products-list-area").removeClass("hidden");
			localStorage.setItem("product_view", "List View");
		});

		$("#image-view").click(function () {
			let $btn = $(this);
			$btn.removeClass("btn-primary");
			$btn.addClass("btn-primary");
			$(".btn-list-view").removeClass("btn-primary");

			$("#products-list-area").addClass("hidden");
			$("#products-grid-area").removeClass("hidden");
			localStorage.setItem("product_view", "Grid View");
		});
	}

	set_view_state() {
		if (this.preference === "List View") {
			$("#list").addClass("btn-primary");
			$("#image-view").removeClass("btn-primary");
		} else {
			$("#image-view").addClass("btn-primary");
			$("#list").removeClass("btn-primary");
		}
	}

	bind_paging_action() {
		let me = this;
		$(".btn-prev, .btn-next").click((e) => {
			e.preventDefault();
			const $btn = $(e.target);
			me.from_filters = false;

			$btn.prop("disabled", true);
			const start = $btn.data("start");

			// Update URL without reload
			let query_params = frappe.utils.get_query_params();
			query_params.start = start;
			let path =
				window.location.pathname +
				"?" +
				frappe.utils.get_url_from_dict(query_params);
			window.history.pushState({}, "", path);

			// Fetch new page via AJAX
			me.make(false);  // false = not from filters, use cached total
		});
	}

	bind_number_paging_action() {
		let me = this;
		$(".btn-num").click((e) => {
			e.preventDefault();
			const $btn = $(e.target);
			me.from_filters = false;

			// Remove active class from all buttons
			$(".btn-num").removeClass("active-page");

			// Add active class to the clicked button
			$btn.addClass("active-page");

			$btn.prop("disabled", true);
			const start = $btn.data("start");

			// Update URL without reload
			let query_params = frappe.utils.get_query_params();
			query_params.start = start;
			let path =
				window.location.pathname +
				"?" +
				frappe.utils.get_url_from_dict(query_params);
			window.history.pushState({}, "", path);

			// Fetch new page via AJAX
			me.make(false);  // false = not from filters, use cached total
		});
	}

	re_render_discount_filters(filter_data) {
		// this.get_discount_filter_html(filter_data);
		// if (this.from_filters) {
		// 	// Bind filter action if triggered via filters
		// 	// if not from filter action, page load will bind actions
		// 	this.bind_discount_filter_action();
		// }
		// // discount filters are rendered with Items (later)
		// // unlike the other filters
		// this.restore_discount_filter();
	}

	render_filter_values(filter_name, column_name, filter_type, options) {

		if(options.length <= 0){
			return `
				<span class="text-center">موردی یافت نشد.</span>
			`
		}

		var htmlContent = '';
		if(options.length >= 18){
			htmlContent = `
				<div class="form-group px-4">
					<input type="text" class="form-control search-filter-search"  
						data-filter-type="${filter_type}" 
						data-filter-name="${column_name}" 
						placeholder="${filter_name}...">
				</div>
			`;
		}
		else
		{
			htmlContent = `
				<div class="form-group px-4">
					<input type="text" class="form-control search-filter-local-search"  
						data-filter-type="${filter_type}" 
						data-filter-name="${column_name}" 
						placeholder="${filter_name}...">
				</div>
			`;
		}
		cachedFilterValues.push({
			"filter_name": column_name,
			"values": options
		});
		for (var filter_option of options) {
			htmlContent += `
				<div class="dropdown-item col filter-option" data-filter-name="${column_name}">
					<label class="m-0 d-flex align-items-center flex-row" for="${filter_option.value}">
						<input type="checkbox"
							class="product-filter specification-filters ${filter_type} ml-2 mr-0"
							id="${filter_option.value}"
							data-filter-name="${column_name}"
							data-filter-value="${filter_option.value}">
						<h3 class="label-area">${filter_option.label || filter_option.value} (${filter_option.count})</h3>
					</label>
				</div>
			`;
		}

		return htmlContent;
	}

	render_filters(filters) {
		var em = this;
		var filters_section = $(".desktop-filters-section");
		var mobile_filters_section = $(".mobile-filters-section");
		cachedFilterValues = [];
		filters_section.empty();
		mobile_filters_section.empty();
		filters.sort((a, b) => {
			if (a.display_order < b.display_order) return -1;
			if (a.display_order > b.display_order) return 1;
			return 0;
		});
		for (var filter of filters) {
			if (filter.type === "range") {
				last_max_price = filter.max;
				last_min_price = filter.min;
				min_price = filter.min;
				max_price = filter.max;
				filters_section.append(`
					<sapn class="d-flex justify-content-center align-items-center flex-column" style="padding: 1rem !important">
						<div class="slider-track-main-1">
							<div class="slider-track-main-2">
								<div id="range-slider-track" class="slider-track"></div>
								<input class="slider-handle" type="range" min="${filter.min}" max="${
					filter.max
				}" value="${
					filter.min
				}" id="range-slide-from" oninput="rangeSlideFrom()">
								<input class="slider-handle" type="range" min="${filter.min}" max="${
					filter.max
				}" value="${
					filter.max
				}"  id="range-slide-to" oninput="rangeSlideTo()">
							</div>
						</div>
						<div class="range-input-detail values d-flex flex-column w-100">
							<p class="w-100 text-right px-3" style="color: #5C5C5C;font-size: 13px;">از ${
								filter.filter_name
							}</p>
							<div class="d-flex justify-content-between" style="font-size: 13px;background-color: #F4F4F4;border-radius: 8px; padding:8px 16px;">
								<p style="color: #5C5C5C;">تومان</p>
								<span id="range-slide-from-value-container" style="color: #000;">
									${filter.min.toLocaleString()}
								</span>
							</div>
							<p class="w-100 text-right px-3" style="color: #5C5C5C; font-size: 13px;">تا ${
								filter.filter_name
							}</p>
							<div class="d-flex justify-content-between" style="font-size: 13px; background-color: #F4F4F4;border-radius: 8px; padding:8px 16px;">
								<p style="color: #5C5C5C;">تومان</p>
								<span id="range-slide-to-value-container" style="color: #000;">
									${filter.max.toLocaleString()}
								</span>
							</div>
						</div>
					</sapn>
				`);
				mobile_filters_section.append(`
					<sapn class="d-flex justify-content-center align-items-center flex-column" style="padding: 1rem !important">
						<div class="slider-track-main-1">
							<div class="slider-track-main-2">
								<div id="mobile-range-slider-track" class="slider-track"></div>
								<input class="slider-handle" type="range" min="${filter.min}" max="${
					filter.max
				}" value="${
					filter.min
				}" id="mobile-range-slide-from" oninput="mobileRangeSlideFrom()">
								<input class="slider-handle" type="range" min="${filter.min}" max="${
					filter.max
				}" value="${
					filter.max
				}"  id="mobile-range-slide-to" oninput="mobileRangeSlideTo()">
							</div>
						</div>
						<div class="range-input-detail values d-flex flex-column w-100">
							<p class="w-100 text-right px-3" style="color: #5C5C5C;font-size: 13px;">از ${
								filter.filter_name
							}</p>
							<div class="d-flex justify-content-between" style="font-size: 13px;background-color: #F4F4F4;border-radius: 8px; padding:8px 16px;">
								<p style="color: #5C5C5C;">تومان</p>
								<span id="mobile-range-slide-from-value-container" style="color: #000;">
									${filter.min.toLocaleString()}
								</span>
							</div>
							<p class="w-100 text-right px-3" style="color: #5C5C5C; font-size: 13px;">تا ${
								filter.filter_name
							}</p>
							<div class="d-flex justify-content-between" style="font-size: 13px; background-color: #F4F4F4;border-radius: 8px; padding:8px 16px;">
								<p style="color: #5C5C5C;">تومان</p>
								<span id="mobile-range-slide-to-value-container" style="color: #000;">
									${filter.max.toLocaleString()}
								</span>
							</div>
						</div>
					</sapn>
				`);
				rangeSlideFillColor();
				rangeSlideFrom();
				rangeSlideTo();
				mobileRangeSlideFillColor();
				mobileRangeSlideFrom();
				mobileRangeSlideTo();
			}
			if (filter.type === "toggle") {
				filters_section.append(`
					 <style>
						:root {
							--toggle-filter-off:rgb(228, 228, 228); /* رنگ زمانی که فیلتر غیرفعال است */
						}

						.form-switch {
							position: relative;
							display: inline-block;
						}

						.form-check-input {
							display: none;
						}

						.slider {
							display: block;
							width: 60px;
							height: 30px;
							background-color: var(--toggle-filter-off);
							border-radius: 99px;
							cursor: pointer;
							transition: background-color 0.3s ease;
						}

						.form-check-input:checked + .slider {
							background-color: var(--primary);
						}

						.form-check-input:checked + .slider::after {
							left: 32px;
						}

						.slider::after {
							content: '';
							position: absolute;
							top: 2px;
							left: 2px;
							width: 26px;
							height: 26px;
							background-color: #ffffff;
							border-radius: 50%;
							transition: left 0.3s ease;
						}
					</style>
					<div class="filter-block text-center d-flex flex-row align-items-center justify-content-between" style="padding: 1rem 1rem;">
						<label class="toggle-label d-flex align-items-center m-0" style="font-size: 14px;">${filter.filter_name}</label>
						<label class="form-switch m-0">
							<input 
								type="checkbox"
								id="existence-toggle"
								class="form-check-input product-filter existance-filter"
								data-filter-name="${filter.column_name}"
								data-filter-value="1">
							<span class="slider"></span>
						</label>

					</div>	
				`);
				mobile_filters_section.append(`
										 <style>
						:root {
							--toggle-filter-off:rgb(228, 228, 228); /* رنگ زمانی که فیلتر غیرفعال است */
						}

						.form-switch {
							position: relative;
							display: inline-block;
						}

						.form-check-input {
							display: none;
						}

						.slider {
							display: block;
							width: 60px;
							height: 30px;
							background-color: var(--toggle-filter-off);
							border-radius: 99px;
							cursor: pointer;
							transition: background-color 0.3s ease;
						}

						.form-check-input:checked + .slider {
							background-color: var(--primary);
						}

						.form-check-input:checked + .slider::after {
							left: 32px;
						}

						.slider::after {
							content: '';
							position: absolute;
							top: 2px;
							left: 2px;
							width: 26px;
							height: 26px;
							background-color: #ffffff;
							border-radius: 50%;
							transition: left 0.3s ease;
						}
					</style>
					<div class="filter-block text-center flex-row-reverse d-flex justify-content-between align-items-center" style="padding: 1rem 1rem;">
						<label class="toggle-label d-block m-0 align-items-center d-flex" style="font-size: 14px;">${filter.filter_name}</label>
						<label class="form-switch m-0">
							<input 
								type="checkbox"
								id="mobile-existence-toggle"
								class="form-check-input product-filter existance-filter"
								data-filter-name="${filter.column_name}"
								data-filter-value="1">
							<span class="slider"></span>
						</label>
					</div>	
				`);
			}
			if (filter.type === "multi_select") {
				// if (!filter.values || filter.values.length <= 0) {
				// 	continue;
				// }

				filters_section.append(`
					<div class="filter-block">
						<div class="dropdown w-100 p-0">
							<div class="btn btn-secondary dropdown-toggle-filter d-flex justify-content-between text-right"
								is-filter-initialized="0" data-filter-name="${filter.filter_name}" data-filter-column="${filter.column_name}" data-filter-type="${filter.filter_type}" id="${
								filter.column_name
							}Dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								${filter.filter_name}<i class="bi bi-chevron-down d-flex"></i>
							</div>
							<div class="dropdown-menu flex-wrap flex-row-reverse filter-block-dropdown-menu" aria-labelledby="${
								filter.column_name
							}Dropdown">
								<div class="filter-searchbox w-100 d-none">
									<div class="search-box">
										<input type="text" placeholder="${filter.filter_name}..." class="search-input">
										<span class="icon">
											<i class="bi bi-search"></i>
										</span>
									</div>
								</div>
								<div class="dropdown-item-list w-100" data-filter-name="${filter.column_name}">
									
								</div>
							</div>
						</div>
					</div>
				`);
				mobile_filters_section.append(`
					<div class="filter-block">
						<div class="dropdown w-100 p-0">
							<div class="btn btn-secondary dropdown-toggle-filter d-flex justify-content-between text-right" 
								is-filter-initialized="0" data-filter-name="${filter.filter_name}" data-filter-column="${filter.column_name}" data-filter-type="${filter.filter_type}" id="${
								filter.column_name
							}Dropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
								${filter.filter_name}<i class="bi bi-chevron-down d-flex"></i>
							</div>
							<div class="dropdown-menu flex-wrap flex-row-reverse filter-block-dropdown-menu" aria-labelledby="${
								filter.column_name
							}Dropdown">
								<div class="filter-searchbox w-100 d-none">
									<div class="search-box">
										<input type="text" placeholder="${filter.filter_name}..." class="search-input">
										<span class="icon">
											<i class="bi bi-search"></i>
										</span>
									</div>
								</div>
								<div class="dropdown-item-list w-100" data-filter-name="${filter.column_name}">
									
								</div>
							</div>
						</div>
					</div>
				`);
			}
		}

		let fetchedFilters = []
		let me = this;
		document
			.querySelectorAll(".dropdown-toggle-filter")
			.forEach((dropdown) => {
				dropdown.addEventListener("click", function () {
					// updateDropdownState(this);
					let filter_name = this.dataset.filterName;
					let column_name = this.dataset.filterColumn;
					let filter_type = this.dataset.filterType;
					if (fetchedFilters.includes(column_name)){
						return;
					}
					fetchedFilters.push(column_name);
					let selectedDropdown = this;
					let dropdownMenues = $(`.dropdown-item-list[data-filter-name="${column_name}"]`);
					for (var dropdownMenu of dropdownMenues){
						$(dropdownMenu).append(`
							<div class="w-100 text-center">
								<div class="spinner-grow text-dark" role="status">
									<span class="sr-only">Loading...</span>
								</div>
							</div>
						`);
					}
					let args = em.get_query_filters();
					args.lazy_load_filter_mode = true;
					args.lazy_load_filter_name = column_name;
					args.lazy_load_filter_value = "";
					frappe.call({
						method: "erpnext.e_commerce.api.get_lazy_filter_data",
						args: {
							query_args: args,
							fill_filters: false,
						},
						callback: function (result) {
							console.log(result);
							let filter_options = result.message.values;
							let html_content = me.render_filter_values(filter_name, column_name, filter_type, filter_options);
							for (var dropdownMenu of dropdownMenues){
								$(dropdownMenu).html(html_content);
							}

							document.querySelectorAll('.search-filter-search').forEach((input) => {
								input.oninput = null;
								input.onkeydown = null; 
								attachFilterSearchHandler(input); 
							});
							document.querySelectorAll('.search-filter-local-search').forEach((input) => {
								input.oninput = null;
								input.onkeydown = null;
								attachFilterLocalSearchHandler(input);
							});
						}
					});
				});
			});

		const existenceToggle = document.getElementById("existence-toggle");
		const mobileExistenceToggle = document.getElementById("mobile-existence-toggle");
		const body = document.body;
		existenceToggle.addEventListener("change", function () {
			const filterName = this.getAttribute("data-filter-name");
			const filterValue = this.checked ? "1" : "0";


			// ذخیره‌سازی وضعیت toggle در localStorage
			localStorage.setItem(
				"existenceFilterState",
				this.checked ? "enabled" : "disabled"
			);
		});
		if (mobileExistenceToggle) {
			mobileExistenceToggle.addEventListener("change", function () {
				const filterName = this.getAttribute("data-filter-name");
				const filterValue = this.checked ? "1" : "0";


				// ذخیره‌سازی وضعیت toggle در localStorage
				localStorage.setItem(
					"existenceFilterState",
					this.checked ? "enabled" : "disabled"
				);
			});
		}
		filters_section.append(`
			<div class="d-flex justify-content-between align-items-center">
				<a class="clear-filters btn-primary" href="/all-products">حذف همه فیلتر ها</a>
			</div>
		`);
		mobile_filters_section.append(`
			<div class="d-flex justify-content-between align-items-center">
				<a class="clear-filters btn-primary" href="/all-products">حذف همه فیلتر ها</a>
			</div>
		`);

		function attachFilterLocalSearchHandler(input) {
			let debounceTimeout;
		
			input.addEventListener("input", function () {
				clearTimeout(debounceTimeout);
				
				debounceTimeout = setTimeout(async () => {
					input.disabled = true;
					let filterName = input.dataset.filterName;
					let searchText = input.value.trim().toLowerCase();
					let dropdownMenus = document.querySelectorAll(`.dropdown-item-list[data-filter-name="${filterName}"]`);

					if (!searchText) {
						var filter_options = cachedFilterValues.find(x => x.filter_name === filterName).values;
						dropdownMenus.forEach((dropdownMenu) => {
							$(dropdownMenu).find(".dropdown-item").remove();
							for (let filter_option of filter_options) {
								$(dropdownMenu).append(`
									<div class="dropdown-item col filter-option" data-filter-name="${filterName}">
										<label class="m-0 d-flex align-items-center flex-row" for="${filter_option.value}">
											<input type="checkbox"
												class="product-filter specification-filters ml-2 mr-0"
												id="${filter_option.value}"
												data-filter-name="${filterName}"
												data-filter-value="${filter_option.value}">
											<h3 class="label-area">${filter_option.label || filter_option.value} (${filter_option.count})</h3>
										</label>
									</div>
								`);
							}
						});
					}
					else
					{
						dropdownMenus.forEach((dropdownMenu) => {
							dropdownMenu.querySelectorAll(".dropdown-item").forEach((el) => {
								el.style.display = "none";
							});
			
							let loader = dropdownMenu.querySelector(".spinner-border");
							if (!loader) {
								let loaderWrapper = document.createElement("div");
								loaderWrapper.className = "text-center my-2";
								loaderWrapper.innerHTML = `
									<div class="spinner-border text-primary" role="status" style="width: 1.5rem; height: 1.5rem;">
										<span class="visually-hidden"></span>
									</div>
								`;
								dropdownMenu.appendChild(loaderWrapper);
							} else {
								loader.parentElement.style.display = "block";
							}
						});
			
						try {
		
							let filter_options = cachedFilterValues
								.find(x => x.filter_name === filterName).values
								.filter(x => (x.label || x.value).toLowerCase().includes(searchText));
			
							dropdownMenus.forEach((dropdownMenu) => {
								$(dropdownMenu).find(".dropdown-item").remove();
			
								for (let filter_option of filter_options) {
									$(dropdownMenu).append(`
										<div class="dropdown-item col filter-option" data-filter-name="${filterName}">
											<label class="m-0 d-flex align-items-center flex-row" for="${filter_option.value}">
												<input type="checkbox"
													class="product-filter specification-filters ml-2 mr-0"
													id="${filter_option.value}"
													data-filter-name="${filterName}"
													data-filter-value="${filter_option.value}">
												<h3 class="label-area">${filter_option.label || filter_option.value} (${filter_option.count})</h3>
											</label>
										</div>
									`);
								}
							});
						} catch (err) {
							console.error("Frappe filter search failed:", err);
						} finally {
							dropdownMenus.forEach((dropdownMenu) => {
								let loader = dropdownMenu.querySelector(".spinner-border");
								if (loader) {
									loader.parentElement.style.display = "none";
								}
							});
						}
					}
					
					input.disabled = false;
					input.focus();

				}, 500); // 200ms debounce delay
			});
		}

		function attachFilterSearchHandler(input) {
			let debounceTimeout;
		
			input.addEventListener("input", function () {
				clearTimeout(debounceTimeout);
				
				debounceTimeout = setTimeout(async () => {
					input.disabled = true;
					let filterName = input.dataset.filterName;
					let searchText = input.value.trim().toLowerCase();
					let dropdownMenus = document.querySelectorAll(`.dropdown-item-list[data-filter-name="${filterName}"]`);

					if (!searchText) {
						var filter_options = cachedFilterValues.find(x => x.filter_name === filterName).values;
						dropdownMenus.forEach((dropdownMenu) => {
							$(dropdownMenu).find(".dropdown-item").remove();
							for (let filter_option of filter_options) {
								$(dropdownMenu).append(`
									<div class="dropdown-item col filter-option" data-filter-name="${filterName}">
										<label class="m-0 d-flex align-items-center flex-row" for="${filter_option.value}">
											<input type="checkbox"
												class="product-filter specification-filters ml-2 mr-0"
												id="${filter_option.value}"
												data-filter-name="${filterName}"
												data-filter-value="${filter_option.value}">
											<h3 class="label-area">${filter_option.label || filter_option.value} (${filter_option.count})</h3>
										</label>
									</div>
								`);
							}
						});
					}
					else
					{
						dropdownMenus.forEach((dropdownMenu) => {
							dropdownMenu.querySelectorAll(".dropdown-item").forEach((el) => {
								el.style.display = "none";
							});
			
							let loader = dropdownMenu.querySelector(".spinner-border");
							if (!loader) {
								let loaderWrapper = document.createElement("div");
								loaderWrapper.className = "text-center my-2";
								loaderWrapper.innerHTML = `
									<div class="spinner-border text-primary" role="status" style="width: 1.5rem; height: 1.5rem;">
										<span class="visually-hidden"></span>
									</div>
								`;
								dropdownMenu.appendChild(loaderWrapper);
							} else {
								loader.parentElement.style.display = "block";
							}
						});
			
						try {
							let args = em.get_query_filters();
							args.lazy_load_filter_mode = true;
							args.lazy_load_filter_name = filterName;
							args.lazy_load_filter_value = searchText;
			
							let response = await frappe.call({
								method: "erpnext.e_commerce.api.get_lazy_filter_data",
								args: {
									query_args: args,
									fill_filters: false,
								},
							});
			
							let filter_options = response.message.values || [];
			
							dropdownMenus.forEach((dropdownMenu) => {
								$(dropdownMenu).find(".dropdown-item").remove();
			
								for (let filter_option of filter_options) {
									$(dropdownMenu).append(`
										<div class="dropdown-item col filter-option" data-filter-name="${filterName}">
											<label class="m-0 d-flex align-items-center flex-row" for="${filter_option.value}">
												<input type="checkbox"
													class="product-filter specification-filters ml-2 mr-0"
													id="${filter_option.value}"
													data-filter-name="${filterName}"
													data-filter-value="${filter_option.value}">
												<h3 class="label-area">${filter_option.label || filter_option.value} (${filter_option.count})</h3>
											</label>
										</div>
									`);
								}
							});
						} catch (err) {
							console.error("Frappe filter search failed:", err);
						} finally {
							dropdownMenus.forEach((dropdownMenu) => {
								let loader = dropdownMenu.querySelector(".spinner-border");
								if (loader) {
									loader.parentElement.style.display = "none";
								}
							});
						}
					}
					
					input.disabled = false;
					input.focus();

				}, 500); // 200ms debounce delay
			});
		}
	}

	get_discount_filter_html(filter_data) {
		$("#discount-filters").remove();
		if (filter_data) {
			$("#product-filters").append(`
				<div id="discount-filters" class="filter-block p-4">
					<div class="filter-label mb-3">${__("Discounts")}</div>
				</div>
			`);

			let html = `<div class="filter-options">`;
			filter_data.forEach((filter) => {
				html += `
					<div class="checkbox">
						<label data-value="${filter[0]}">
							<input type="radio"
								class="product-filter discount-filter"
								name="discount" id="${filter[0]}"
								data-filter-name="discount"
								data-filter-value="${filter[0]}"
								style="width: 14px !important"
							>
								<span class="label-area" for="${filter[0]}">
									${filter[1]}
								</span>
						</label>
					</div>
				`;
			});
			html += `</div>`;

			$("#discount-filters").append(html);
		}
	}

	restore_discount_filter() {
		const filters = frappe.utils.get_query_params();
		let field_filters = filters.field_filters;
		if (!field_filters) return;

		field_filters = JSON.parse(field_filters);

		if (field_filters && field_filters["discount"]) {
			const values = field_filters["discount"];
			const selector = values
				.map((value) => {
					return `input[data-filter-name="discount"][data-filter-value="${value}"]`;
				})
				.join(",");
			$(selector).prop("checked", true);
			this.field_filters = field_filters;
		}
	}

	bind_discount_filter_action() {
		let me = this;
		$(".discount-filter").on("change", (e) => {
			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(":checked");

			const { filterValue: filter_value } = $checkbox.data();

			delete this.field_filters["discount"];

			if (is_checked) {
				this.field_filters["discount"] = [];
				this.field_filters["discount"].push(filter_value);
			}

			if (this.field_filters["discount"].length === 0) {
				delete this.field_filters["discount"];
			}

			me.change_route_with_filters();
		});
	}

	// Removed: existence filter should be off by default and only set when user toggles it
	// has_selling_stock(args) {
	// 	const currentUrl = new URL(window.location.href);
	// 	const startParam = currentUrl.searchParams.get("start");
	// 	if (
	// 		!currentUrl.searchParams.has("existence_filters") &&
	// 		startParam === null
	// 	) {
	// 		currentUrl.searchParams.append(
	// 			"existence_filters",
	// 			'{"has_selling_stock":[1]}'
	// 		);
	//
	// 		window.history.pushState({}, "", currentUrl.toString());
	// 	}
	// }

	has_price_range() {
		return;
		const currentUrl = new URL(window.location.href);
		const startParam = currentUrl.searchParams.get("start");

		if (
			!currentUrl.searchParams.has("price_range_filters") &&
			startParam === null
		) {
			let sliderOne = document.getElementById("slider-1");
			let sliderTwo = document.getElementById("slider-2");

			currentUrl.searchParams.append(
				"price_range_filters",
				`{"price_range":[${sliderOne.value},${sliderTwo.value}] }`
			);

			window.history.pushState({}, "", currentUrl.toString());
		}
	}

	bind_filters() {
		let me = this;
		this.field_filters = {};
		this.attribute_filters = {};
		this.specification_filters = {};
		this.tag_filters = {};
		this.sort_filters = {};
		this.existence_filters = {};
		this.price_range_filters = {};

		let debounceTimer;

		$(document).click('.slider-handle', function (e) {
			clearTimeout(debounceTimer);
			debounceTimer = setTimeout(() => {
				var valPriceFromOriginal = $("#range-slide-from").val();
				var valPriceFrom = +valPriceFromOriginal * 10;
				var valPriceToOriginal = $("#range-slide-to").val();
				var valPriceTo = +valPriceToOriginal * 10;

				if(valPriceFromOriginal == last_min_price && valPriceToOriginal == last_max_price){
					return;
				}

				if(parseInt(valPriceFromOriginal) == parseInt(last_min_price) && parseInt(valPriceToOriginal) == parseInt(last_max_price)){
					return;
				}

				last_min_price = valPriceFromOriginal;
				last_max_price = valPriceToOriginal;

				if (typeof me.price_range_filters === "string") {
					try {
						me.price_range_filters = JSON.parse(
							me.price_range_filters
						);
					} catch (error) {
						me.price_range_filters = {}; // Reset if parsing fails
					}
				}

				if(Number.isNaN(valPriceFrom) && Number.isNaN(valPriceTo)){
					return;
				}

				me.price_range_filters["price_range"] = [
					valPriceFrom,
					valPriceTo,
				];

				me.change_route_with_filters();
				// Trigger an event or make an API call here
				$(".slider-handle").trigger("change");
			}, 500);
		});

		$(".sort-box-list .label-area").on("click", function () {
			// حذف کلاس 'selected' از تمام label-area ها
			$(".sort-box-list .label-area").removeClass("selected");

			// اضافه کردن کلاس 'selected' به عنصری که بر روی آن کلیک شده است
			$(this).addClass("selected");
		});

		$(document).on("change", ".sort-filters", function (e) {
			me.from_filters = true;
			const value = $(this).data("sortValue");
			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(":checked");
			const {
				sortName: sort_name,
				sortValue: sort_value,
				sortTranslate: sort_translate,
			} = $checkbox.data();
			this.sort_filters = [];
			var $button = $(".sort-drop-down");
			$button.text(sort_translate || sort_value);
			if (is_checked) {
				this.sort_filters[sort_name] =
					this.sort_filters[sort_name] || [];
				if (!in_list(this.sort_filters[sort_name], sort_value)) {
					this.sort_filters[sort_name].push(sort_value);
				}
			} else {
				this.sort_filters[sort_name] =
					this.sort_filters[sort_name] || [];
				this.sort_filters[sort_name] = this.sort_filters[
					sort_name
				].filter((v) => v !== sort_value);
			}
			if (this.sort_filters[sort_name].length === 0) {
				delete this.sort_filters[sort_name];
			}
			me.sort_filters = {
				"sorts": [
					value
				]
			};
			me.change_route_with_filters();
		});

		$(document).on("click", ".product-filter", (e) => {
			me.from_filters = true;

			const $checkbox = $(e.target);
			const is_checked = $checkbox.is(":checked");

			if ($checkbox.is(".attribute-filter")) {
				const {
					attributeName: attribute_name,
					attributeValue: attribute_value,
				} = $checkbox.data();

				if (is_checked) {
					this.attribute_filters[attribute_name] =
						this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name].push(
						attribute_value
					);
				} else {
					this.attribute_filters[attribute_name] =
						this.attribute_filters[attribute_name] || [];
					this.attribute_filters[attribute_name] =
						this.attribute_filters[attribute_name].filter(
							(v) => v !== attribute_value
						);
				}

				if (this.attribute_filters[attribute_name].length === 0) {
					delete this.attribute_filters[attribute_name];
				}
			} else if (
				$checkbox.is(".field-filter") ||
				$checkbox.is(".discount-filter")
			) {
				const { filterName: filter_name, filterValue: filter_value } =
					$checkbox.data();

				if ($checkbox.is(".discount-filter")) {
					// clear previous discount filter to accomodate new
					delete this.field_filters["discount"];
				}
				if (is_checked) {
					this.field_filters[filter_name] =
						this.field_filters[filter_name] || [];
					if (
						!in_list(this.field_filters[filter_name], filter_value)
					) {
						this.field_filters[filter_name].push(filter_value);
					}
				} else {
					this.field_filters[filter_name] =
						this.field_filters[filter_name] || [];
					this.field_filters[filter_name] = this.field_filters[
						filter_name
					].filter((v) => v !== filter_value);
				}

				if (this.field_filters[filter_name].length === 0) {
					delete this.field_filters[filter_name];
				}
			} else if ($checkbox.is(".specification-filters")) {
				const {
					filterName: attribute_name,
					filterValue: attribute_value,
				} = $checkbox.data();

				if (is_checked) {
					this.specification_filters[attribute_name] =
						this.specification_filters[attribute_name] || [];
					if (
						!in_list(
							this.specification_filters[attribute_name],
							attribute_value
						)
					) {
						this.specification_filters[attribute_name].push(
							attribute_value
						);
					}
				} else {
					this.specification_filters[attribute_name] =
						this.specification_filters[attribute_name] || [];
					this.specification_filters[attribute_name] =
						this.specification_filters[attribute_name].filter(
							(v) => v !== attribute_value
						);
				}

				if (this.specification_filters[attribute_name].length === 0) {
					delete this.specification_filters[attribute_name];
				}
			} else if ($checkbox.is(".tag-filters")) {
				const {
					attributeName: attribute_name,
					attributeValue: attribute_value,
				} = $checkbox.data();

				if (is_checked) {
					this.tag_filters[attribute_name] =
						this.tag_filters[attribute_name] || [];
					if (
						!in_list(
							this.tag_filters[attribute_name],
							attribute_value
						)
					) {
						this.tag_filters[attribute_name].push(attribute_value);
					}
				} else {
					this.tag_filters[attribute_name] =
						this.tag_filters[attribute_name] || [];
					this.tag_filters[attribute_name] = this.tag_filters[
						attribute_name
					].filter((v) => v !== attribute_value);
				}

				if (this.tag_filters[attribute_name].length === 0) {
					delete this.tag_filters[attribute_name];
				}
			} else if ($checkbox.is(".sort-filters")) {
				const {
					sortName: sort_name,
					sortValue: sort_value,
					sortTranslate: sort_translate,
				} = $checkbox.data();
				delete this.sort_filters[sort_name];
				var $button = $(".sort-drop-down");
				$button.text(sort_translate || sort_value);
				if (is_checked) {
					this.sort_filters[sort_name] =
						this.sort_filters[sort_name] || [];
					if (!in_list(this.sort_filters[sort_name], sort_value)) {
						this.sort_filters[sort_name].push(sort_value);
					}
				} else {
					this.sort_filters[sort_name] =
						this.sort_filters[sort_name] || [];
					this.sort_filters[sort_name] = this.sort_filters[
						sort_name
					].filter((v) => v !== sort_value);
				}

				if (this.sort_filters[sort_name].length === 0) {
					delete this.sort_filters[sort_name];
				}
			} else if ($checkbox.is(".existance-filter")) {
				const { filterName: filter_name, filterValue: filter_value } =
					$checkbox.data();

				if ($checkbox.is(".discount-filter")) {
					// clear previous discount filter to accomodate new
					delete this.field_filters["discount"];
				}
				if (is_checked) {
					this.existence_filters[filter_name] = [1];
				} else {
					delete this.existence_filters[filter_name];
				}
			}
			me.change_route_with_filters();
		});

		// bind filter lookup input box
		$(".filter-lookup-input").on(
			"keydown",
			frappe.utils.debounce((e) => {
				const $input = $(e.target);
				const keyword = ($input.val() || "").toLowerCase();
				const $filter_options = $input.next(".filter-options");

				$filter_options.find(".filter-lookup-wrapper").show();
				$filter_options.find(".filter-lookup-wrapper").each((i, el) => {
					const $el = $(el);
					const value = $el.data("value").toLowerCase();
					if (!value.includes(keyword)) {
						$el.hide();
					}
				});
			}, 300)
		);

		// this.updateSelectedFilters();
	}

	change_route_with_filters() {
		// Reset cached total when filters change
		cachedTotalCount = null;

		let route_params = frappe.utils.get_query_params();
		delete route_params.field_filters;
		delete route_params.attribute_filters;
		delete route_params.specification_filters;
		delete route_params.tag_filters;
		delete route_params.sort_filters;
		delete route_params.existence_filters;
		delete route_params.price_range_filters;
		delete route_params.start;

		let start = this.if_key_exists(route_params.start) || 0;

		if (this.from_filters) {
			start = 0; // show items from first page if new filters are triggered
		}

		// Convert route_params to a string
		let route_params_string = new URLSearchParams(route_params).toString();

		const query_string = this.get_query_string({
			start: start,
			field_filters: JSON.stringify(
				this.if_key_exists(this.field_filters)
			),
			attribute_filters: JSON.stringify(
				this.if_key_exists(this.attribute_filters)
			),
			specification_filters: JSON.stringify(
				this.if_key_exists(this.specification_filters)
			),
			tag_filters: JSON.stringify(this.if_key_exists(this.tag_filters)),
			sort_filters: JSON.stringify(this.if_key_exists(this.sort_filters)),
			existence_filters: JSON.stringify(
				this.if_key_exists(this.existence_filters)
			),
			price_range_filters: JSON.stringify(
				this.if_key_exists(this.price_range_filters)
			),
		});

		// Combine query_string and route_params_string
		let combined_query_string = `${query_string}&${route_params_string}`;

		if (this._last_query_signature === combined_query_string) {
			return;
		}
		this._last_query_signature = combined_query_string;

		window.history.pushState(
			"filters",
			"",
			`${location.pathname}?` + combined_query_string
		);
		$(".page_content input").prop("disabled", true);
		this.make(true);
		$(".page_content input").prop("disabled", false);

		this.updateSelectedFilters();
	}

	restore_filters_state() {
		$(".sort-box-list .label-area").off("click");
		$(".sort-box-list .label-area").on("click", function () {
			// ابتدا تمام المنت‌ها را پاک کنید (در صورتی که می‌خواهید فقط یک انتخاب فعال باشد)
			$(".sort-box-list .label-area").removeClass("selected");

			// سپس به المنت کلیک‌شده کلاس "selected" اضافه کنید
			$(this).addClass("selected");
		});

		const filters = frappe.utils.get_query_params();
		let {
			field_filters,
			attribute_filters,
			specification_filters,
			tag_filters,
			sort_filters,
			existence_filters,
			price_range_filters,
		} = filters;

		if (field_filters) {
			field_filters = JSON.parse(field_filters);
			for (let fieldname in field_filters) {
				const values = field_filters[fieldname];
				const selector = values
					.map((value) => {
						return `input[data-filter-name="${fieldname}"][data-filter-value="${value}"]`;
					})
					.join(",");
				$(selector).prop("checked", true);
			}
			this.field_filters = field_filters;
		}
		if (attribute_filters) {
			attribute_filters = JSON.parse(attribute_filters);
			for (let attribute in attribute_filters) {
				const values = attribute_filters[attribute];
				const selector = values
					.map((value) => {
						return `input[data-attribute-name="${attribute}"][data-attribute-value="${value}"]`;
					})
					.join(",");
				$(selector).prop("checked", true);
			}
			this.attribute_filters = attribute_filters;
		}
		if (existence_filters) {
			existence_filters = JSON.parse(existence_filters);
			for (let attribute in existence_filters) {
				const values = existence_filters[attribute];
				// For toggle filters (existance-filter class), just check by filter name
				const selector = `input.existance-filter[data-filter-name="${attribute}"]`;
				$(selector).prop("checked", true);
			}
			this.existence_filters = existence_filters;
		}
		if (price_range_filters) {
			// Ensure price_range_filters is always an object, not a raw JSON string,
			// to prevent double-encoding when rebuilding the route.
			try {
				this.price_range_filters =
					typeof price_range_filters === "string"
						? JSON.parse(price_range_filters)
						: price_range_filters;
			} catch (e) {
				this.price_range_filters = {};
			}
		}

		if (specification_filters) {
			specification_filters = JSON.parse(specification_filters);
			for (let attribute in specification_filters) {
				const values = specification_filters[attribute];
				const selector = values
					.map((value) => {
						return `input[data-attribute-name="${attribute}"][data-attribute-value="${value}"]`;
					})
					.join(",");
				$(selector).prop("checked", true);
			}
			this.specification_filters = specification_filters;
		}

		if (tag_filters) {
			tag_filters = JSON.parse(tag_filters);
			for (let attribute in tag_filters) {
				const values = tag_filters[attribute];
				const selector = values
					.map((value) => {
						return `input[data-attribute-name="${attribute}"][data-attribute-value="${value}"]`;
					})
					.join(",");
				$(selector).prop("checked", true);
			}
			this.tag_filters = tag_filters;
		}

		if (sort_filters) {
			sort_filters = JSON.parse(sort_filters);
			for (let attribute in sort_filters) {
				const values = sort_filters[attribute];
				const selector = values
					.map((value) => {
						return `input[data-sort-name="${attribute}"][data-sort-value="${value}"]`;
					})
					.join(",");

				$(selector).prop("checked", true);
				const valueToTranslate = values[0];
				const translatedValue = website_sort_dropdown_label(valueToTranslate);

				$(".sort-drop-down").text(translatedValue);
			}
			this.sort_filters = sort_filters;
		} else {
			const urlParams = frappe.utils.get_query_params();
			const searchName = urlParams.name || "";
			this.sort_filters = resolve_implicit_website_sort_filters(searchName, {});
			const implicitValue = this.sort_filters.sorts[0];
			const selector = `input[data-sort-name="sorts"][data-sort-value="${implicitValue}"]`;
			$(selector).prop("checked", true);
			$(".sort-drop-down").text(website_sort_dropdown_label(implicitValue));
		}
		this.updateSelectedFilters();
	}

	render_no_products_section(error = false) {
		let error_section = `
			<div class="mt-4 w-100 alert alert-error font-md">
				Something went wrong. Please refresh or contact us.
			</div>
		`;
		let no_results_section = `
			<div class="cart-empty frappe-card mt-4">
				<div class="cart-empty-state">
					<img src="/assets/erpnext/images/ui-states/cart-empty-state.png" alt="Empty Cart">
				</div>
				<div class="cart-empty-message mt-4">${__("محصولی یافت نشد")}</p>
			</div>
		`;

		this.products_section.append(
			error ? error_section : no_results_section
		);
	}

	updateSelectedFilters() {
		var me = this;
		const selectedFiltersContainer = $(".filter-selected-list");
		selectedFiltersContainer.empty(); // Clear previous filters

		// Prevent binding the click handler multiple times
		selectedFiltersContainer.off("click", ".remove-filter");

		function addFilterPill(name, value) {
			// Create a unique identifier to prevent duplicates
			const filterId = `${name}-${value}`;

			// Check if the filter already exists
			if (
				$(`.filter-selected-pill[data-filter-id="${filterId}"]`)
					.length === 0
			) {
				const pill = $(`
					<span class="filter-selected-pill" data-filter-id="${filterId}">
						${value} <i class="bi bi-x-lg d-flex remove-filter" data-filter-name="${name}" data-filter-value="${value}"></i>
					</span>
				`);
				selectedFiltersContainer.append(pill);
			}
		}

		// Process different filters
		if (this.field_filters) {
			for (let fieldname in this.field_filters) {
				this.field_filters[fieldname].forEach((value) =>
					addFilterPill(fieldname, value)
				);
			}
		}
		if (this.attribute_filters) {
			for (let attribute in this.attribute_filters) {
				this.attribute_filters[attribute].forEach((value) =>
					addFilterPill(attribute, value)
				);
			}
		}
		if (this.specification_filters) {
			for (let spec in this.specification_filters) {
				this.specification_filters[spec].forEach((value) =>
					addFilterPill(spec, value)
				);
			}
		}
		if (this.tag_filters) {
			for (let tag in this.tag_filters) {
				this.tag_filters[tag].forEach((value) =>
					addFilterPill(tag, value)
				);
			}
		}

		// Remove filter on click
		selectedFiltersContainer.on("click", ".remove-filter", function () {
			const filterName = $(this).data("filter-name");
			const filterValue = $(this).data("filter-value");

			// Uncheck the corresponding input
			$(
				`input[data-filter-name="${filterName}"][data-filter-value="${filterValue}"]`
			).prop("checked", false);

			const removeFromBucket = (bucket) => {
				if (!(filterName in bucket)) {
					return false;
				}

				bucket[filterName] = bucket[filterName] || [];
				bucket[filterName] = bucket[filterName].filter(
					(v) => v !== filterValue
				);

				if (bucket[filterName].length === 0) {
					delete bucket[filterName];
				}

				return true;
			};

			let filterChanged =
				removeFromBucket(me.field_filters) ||
				removeFromBucket(me.attribute_filters) ||
				removeFromBucket(me.specification_filters) ||
				removeFromBucket(me.tag_filters);

			if (!filterChanged && filterName in me.sort_filters) {
				delete me.sort_filters[filterName];
				filterChanged = true;
			}

			if (!filterChanged && filterName in me.existence_filters) {
				delete me.existence_filters[filterName];
				filterChanged = true;
			}

			if (!filterChanged && me.price_range_filters?.[filterName]) {
				delete me.price_range_filters[filterName];
				filterChanged = true;
			}

			if (!filterChanged) {
				return;
			}

			// Remove the pill after the state is updated
			$(this).parent().remove();

			me.change_route_with_filters();
		});
	}

	render_item_sub_categories(categories) {
		if (categories && categories.length) {
			let sub_group_html = `
				<div class="sub-category-container scroll-categories">
			`;

			categories.forEach((category) => {
				sub_group_html += `
					<a href="/${category.route || "#"}" style="text-decoration: none;">
						<div class="category-pill">
							${category.name}
						</div>
					</a>
				`;
			});
			sub_group_html += `</div>`;

			$("#product-listing").prepend(sub_group_html);
		}
	}

	get_query_string(object) {
		const url = new URLSearchParams();
		for (let key in object) {
			const value = object[key];

			if (value) {
				url.append(key, value);
			}
		}
		return url.toString();
	}

	if_key_exists(obj) {
		let exists = false;
		for (let key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key]) {
				exists = true;
				break;
			}
		}
		return exists ? obj : undefined;
	}

	convert_arabic_persian(input) {

		if(!input){
			return '';
		}

		if (typeof input !== "string") {
			console.warn("Input is not a string");
			return input;
		}

		if (input.length === 0) {
			console.warn("Input string is empty");
			return input;
		}

		// Check if the string contains Arabic characters
		const arabicCharPattern = /[\u0600-\u06FF]/;
		if (!arabicCharPattern.test(input)) {
			console.warn("Input does not contain Arabic characters");
			return input;
		}

		return input
			.replace(/\u064A/g, "\u06CC") // Convert Arabic ي to Persian ی
			.replace(/\u0643/g, "\u06A9"); // Convert Arabic ك to Persian ک
	}
};
